module.exports = __webpack_public_path__ + "img/cl_register_logo.a6a79f17.png";